import { Component, Input, OnInit } from '@angular/core';
import { ActionSheetController, ModalController, NavController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { GroupService } from 'src/app/services/group.service';
import { AddEditGroupComponent } from '../add-edit-group/add-edit-group.component';

@Component({
  selector: 'app-group-card',
  templateUrl: './group-card.component.html',
  styleUrls: ['./group-card.component.scss'],
})
export class GroupCardComponent implements OnInit {

  @Input() public id: any;
  @Input() public group: any;

  constructor(
    public authService: AuthService,
    public groupService: GroupService,
    public modalController: ModalController,
    public actionSheetController: ActionSheetController,
    public navController: NavController
  ) {

  }

  ngOnInit() {
    console.log(this.id);
    this.id = this.group.id;
    if (this.id && !this.group) {
      this.groupService.getGroup(this.id).then((group) => {
        this.group = group;
      });
    }
  }


  async presentActionSheet(group) {
    const actionSheet = await this.actionSheetController.create({
      header: 'Options',
      cssClass: 'feeds-action-sheet',
      buttons: [{
        text: 'Open',
        icon: 'open-outline',
        cssClass: 'feeds-action-sheet-btn',
        handler: () => {
          console.log('Open clicked');
          this.openDetailPage(group);
        }
      },
      {
        text: 'Edit',
        icon: 'create-outline',
        cssClass: 'feeds-action-sheet-btn',
        handler: () => {
          console.log('Open clicked');
          this.editGroup(group);
        }
      },
      {
        text: 'Like',
        icon: 'thumbs-up-sharp',
        handler: () => {
          this.like(group);
        }
      },
      {
        text: 'Share',
        icon: 'share-outline',
        handler: () => {
        }
      },
      {
        text: 'Cancel',
        icon: 'close-outline',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();
  }

  async editGroup(group) {
    const modal = await this.modalController.create({
      component: AddEditGroupComponent,
      cssClass: 'add-edit-group-modal',
      initialBreakpoint: 0.8,
      breakpoints: [0, 0.8, 1],
      componentProps: {
        group,
      }
    });

  }

  gotToComment(group: any) {
    throw new Error('Method not implemented.');
  }
  like(group: any) {
    throw new Error('Method not implemented.');
  }
  openDetailPage(group: any) {
    this.navController.navigateForward(['/group', group.id]);
  }


  ionviewDidLeave() {

  }

}
